export default "__VITE_ASSET__QkP3XGCo__"